import { defaultPermissions, adminPermissions } from "../utils/permissions";

export const usePermissions = ({ profil, user, ownerUid }) => {
  const aileYetkisi =
    profil?.aileYetkisi ||
    (user?.uid === ownerUid ? "Aile Yöneticisi" : "Aile Üyesi");

  const yoneticiMi =
    aileYetkisi === "Aile Yöneticisi" || user?.uid === ownerUid;

  const basePermissions = yoneticiMi ? adminPermissions : defaultPermissions;

  // Yönetici (aileYetkisi === "Aile Yöneticisi" veya ownerUid) ise
  // profil.permissions override'ı uygulanmaz — adminPermissions her zaman tam yetki verir.
  // Böylece sonradan yönetici yapılan kullanıcılar eski kısıtlı permissions'larından
  // bağımsız olarak yönetim sayfasına ve tüm işlemlere erişebilir.
  // Yöneticiden alınan (Aile Üyesi yapılan) kullanıcılar ise kendi kayıtlı
  // permissions'larına döner.
const permissions = yoneticiMi
  ? { pages: { ...adminPermissions.pages }, actions: { ...adminPermissions.actions } }
  : {
      pages: {
        ...basePermissions.pages,
        ...(profil?.permissions?.pages || {}),
        calendar: profil?.permissions?.pages?.calendar ?? true,
      },
      actions: {
        ...basePermissions.actions,
        ...(profil?.permissions?.actions || {}),
      },
    };

  const sayfaIzniVarMi = (pageKey) => {
    // Yönetici her sayfayı görebilir
    if (yoneticiMi) return true;
    // Yönetici olmayan kullanıcı için sayfalar varsayılan açık;
    // aile yöneticisi isterse ilgili sayfayı false yaparak kısıtlar.
    return permissions?.pages?.[pageKey] !== false;
  };

  const islemIzniVarMi = (actionKey) => {
    return permissions?.actions?.[actionKey] === true;
  };

  const kayitSahibiMi = (kayit) => {
    return (
      kayit.ekleyenUid === user?.uid ||
      kayit.uid === user?.uid ||
      kayit.ownerUid === user?.uid
    );
  };

  const silebilirMi = (kayit) => {
    return yoneticiMi || kayitSahibiMi(kayit);
  };

  return {
    aileYetkisi,
    yoneticiMi,
    permissions,
    sayfaIzniVarMi,
    islemIzniVarMi,
    kayitSahibiMi,
    silebilirMi,
  };
};
